import React, { FC, useContext } from "react";
import Drawer from "@mui/material/Drawer";
import { List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import PeopleIcon from "@mui/icons-material/People";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Store } from "../store";
import types from "../store/types";
import { useTranslation } from 'react-i18next';
import { UserTypeTeacher } from "../common/type";

const Sidebar: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state, dispatch } = useContext(Store);
  const { isAuthenticated, logout } = useAuth0();

  const handleDrawer =
    () => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      closeDrawer();
    };

  const closeDrawer = () => {
    dispatch({ type: types.SIDEBAR_CLICK });
  };

  const handleLogout = async () => {
    try {
      if (isAuthenticated) {
        logout({
          logoutParams: {
            returnTo: window.location.origin
          }
        });
      }
      dispatch({ type: types.SIDEBAR_CLICK });
    } catch (e) {
      alert(e);
    }
  };

  const changeRoute = (url: string) => {
    dispatch({ type: types.SIDEBAR_CLICK });
    navigate(url);
  };

  const menuList = () => (
    <List>
      <ListItem button key="home" onClick={() => changeRoute("/home")}>
        <ListItemIcon>
          <HomeOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('sideMenu.home')} />
      </ListItem>
      <ListItem button key="account" onClick={() => changeRoute("/account")}>
        <ListItemIcon>
          <PersonOutlineOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('sideMenu.account')} />
      </ListItem>
      <ListItem button key="userInfo" onClick={() => changeRoute(`/userInfo`)}>
        <ListItemIcon>
          <BadgeOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('sideMenu.userInfo')} />
      </ListItem>
      <ListItem button key="userAchievements" onClick={() => changeRoute(`/userAchievements`)}>
        <ListItemIcon>
          <StarBorderOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('sideMenu.userAchievements')} />
      </ListItem>
      <ListItem button key="language" onClick={() => changeRoute("/language")}>
        <ListItemIcon>
          <LanguageOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('sideMenu.language')} />
      </ListItem>
      <ListItem button key="link" onClick={() => changeRoute("/link")}>
        <ListItemIcon>
          <LinkOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('sideMenu.link')} />
      </ListItem>
      {state.userType === UserTypeTeacher && (
        <ListItem
          button
          key="users"
          onClick={() => changeRoute("/users")}
        >
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary={t('sideMenu.users')} />
        </ListItem>
      )}
      {/* 初期リリースでは仕様から削除 */}
      {/* <ListItem button key="point" onClick={() => changeRoute("/point")}>
          <ListItemIcon>
            <CurrencyRubleIcon />
          </ListItemIcon>
          <ListItemText primary="POINT" />
        </ListItem> */}
      <ListItem button key="help" onClick={() => changeRoute("/help")}>
        <ListItemIcon>
          <HelpOutlineOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('sideMenu.help')} />
      </ListItem>
      <ListItem button key="logout" onClick={handleLogout}>
        <ListItemIcon>
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText primary={t('sideMenu.logout')} />
      </ListItem>
    </List>
  );

  return (
    <div>
      <Drawer anchor="left" open={state.sidebarState} onClose={handleDrawer()}>
        {menuList()}
      </Drawer>
    </div>
  );
};

export default Sidebar;
